import './ProgressBar.css';

export interface ProgressBarProps {
  /** Accessible label — required, since a bare coloured bar communicates
   * nothing to a screen-reader user (a11y.md §2). */
  label: string;
  /** 0–100. Omit (with `indeterminate`) for an unknown-duration operation. */
  value?: number;
  indeterminate?: boolean;
  /** Shows the label and percentage as visible text, not just as the
   * accessible name. */
  showLabel?: boolean;
}

export function ProgressBar({ label, value = 0, indeterminate = false, showLabel = false }: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));
  return (
    <div className="dpr-progress-bar">
      {showLabel ? (
        <div className="dpr-progress-bar__label-row">
          <span>{label}</span>
          {!indeterminate ? <span>{Math.round(clamped)}%</span> : null}
        </div>
      ) : null}
      <div
        className="dpr-progress-bar__track"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={indeterminate ? undefined : clamped}
      >
        <div
          className={['dpr-progress-bar__fill', indeterminate ? 'dpr-progress-bar__fill--indeterminate' : null]
            .filter(Boolean)
            .join(' ')}
          style={indeterminate ? undefined : { width: `${clamped}%` }}
        />
      </div>
    </div>
  );
}
